import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import routes, { renderRoutes } from "./Routes";
import { BASENAME } from "./config/constant";

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Silently ignore auth-related errors — axios interceptor handles redirect
    if (error?.message?.includes("401") || error?.message?.includes("403")) {
      return;
    }
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return null; // Interceptor is already redirecting to /login
    }
    return this.props.children;
  }
}

const App = () => {
  return (
    <React.Fragment>
      <ErrorBoundary>
        <Router basename={BASENAME}>{renderRoutes(routes)}</Router>
      </ErrorBoundary>
    </React.Fragment>
  );
};

export default App;
